module.exports = __webpack_public_path__ + "assets/AirbnbCereal-ExtraBold.0a0cbe1eca15f71b7187b38b1173eb98.ttf";